
      import API from "!../../../.yarn/__virtual__/style-loader-virtual-89f6844a88/4/.yarn/berry/cache/style-loader-npm-3.3.4-e2ff5c12be-10c0.zip/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../.yarn/__virtual__/style-loader-virtual-89f6844a88/4/.yarn/berry/cache/style-loader-npm-3.3.4-e2ff5c12be-10c0.zip/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      
      import setAttributes from "!../../../.yarn/__virtual__/style-loader-virtual-89f6844a88/4/.yarn/berry/cache/style-loader-npm-3.3.4-e2ff5c12be-10c0.zip/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../.yarn/__virtual__/style-loader-virtual-89f6844a88/4/.yarn/berry/cache/style-loader-npm-3.3.4-e2ff5c12be-10c0.zip/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../.yarn/__virtual__/style-loader-virtual-89f6844a88/4/.yarn/berry/cache/style-loader-npm-3.3.4-e2ff5c12be-10c0.zip/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../.yarn/__virtual__/css-loader-virtual-b5b6b5adb5/4/.yarn/berry/cache/css-loader-npm-7.1.2-7540f12884-10c0.zip/node_modules/css-loader/dist/cjs.js!../../../.yarn/__virtual__/postcss-loader-virtual-08a3ad762d/4/.yarn/berry/cache/postcss-loader-npm-8.1.1-20cf547c92-10c0.zip/node_modules/postcss-loader/dist/cjs.js!../../../.yarn/__virtual__/sass-loader-virtual-925cd4d94a/4/.yarn/berry/cache/sass-loader-npm-14.2.1-dc50026ea1-10c0.zip/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].use[3]!./application.scss";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;
options.insert = function insertAtTop(element) {
  var parent = document.querySelector('head');
  // eslint-disable-next-line no-underscore-dangle
  var lastInsertedElement = window._lastElementInsertedByStyleLoader;

  if (!lastInsertedElement) {
    parent.insertBefore(element, parent.firstChild);
  } else if (lastInsertedElement.nextSibling) {
    parent.insertBefore(element, lastInsertedElement.nextSibling);
  } else {
    parent.appendChild(element);
  }

  // eslint-disable-next-line no-underscore-dangle
  window._lastElementInsertedByStyleLoader = element;
};
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../.yarn/__virtual__/css-loader-virtual-b5b6b5adb5/4/.yarn/berry/cache/css-loader-npm-7.1.2-7540f12884-10c0.zip/node_modules/css-loader/dist/cjs.js!../../../.yarn/__virtual__/postcss-loader-virtual-08a3ad762d/4/.yarn/berry/cache/postcss-loader-npm-8.1.1-20cf547c92-10c0.zip/node_modules/postcss-loader/dist/cjs.js!../../../.yarn/__virtual__/sass-loader-virtual-925cd4d94a/4/.yarn/berry/cache/sass-loader-npm-14.2.1-dc50026ea1-10c0.zip/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].use[3]!./application.scss";
       export default content && content.locals ? content.locals : undefined;
